import { createContext, useContext } from 'react'

import { type AgentPanelState, useAgentPanelState } from '../AgentChat/useAgentPanelState'

const InternalAgentContext = createContext<AgentPanelState | null>(null)

/**
 * Panel state for the internal agent, held above the router `Outlet` in
 * `InternalLayout` so the chat survives navigation between internal pages.
 */
export function InternalAgentProvider({ children }: { children: React.ReactNode }) {
  const value = useAgentPanelState('internalAgent')
  return <InternalAgentContext.Provider value={value}>{children}</InternalAgentContext.Provider>
}

export function useInternalAgent(): AgentPanelState {
  const ctx = useContext(InternalAgentContext)
  if (!ctx) throw new Error('useInternalAgent must be used inside an InternalAgentProvider')
  return ctx
}
